import { useAuth } from "../AuthContext";

/**
 * Plan / fiyatlandırma modalı. Kota dolunca (402) veya "planım" tıklanınca açılır.
 * Max planın Claude ayrıcalığı "yakında" — pipeline henüz yok (backend provider'ı
 * gpt'ye sabitliyor). Ödeme akışı henüz bağlı değil; şimdilik planları tanıtır.
 */
const PLANLAR = [
  { id: "free", ad: "Ücretsiz", fiyat: "₺0", vurgu: false,
    ozellikler: ["Ayda 3 GPT analizi", "Tüm istatistik ve sorgular", "Piyasa sapması verisi"] },
  { id: "pro", ad: "Pro", fiyat: "₺—", vurgu: true,
    ozellikler: ["Sınırsız GPT analizi", "Öncelikli kuyruk", "Tüm Ücretsiz özellikleri"] },
  { id: "max", ad: "Max", fiyat: "₺—", vurgu: false,
    ozellikler: ["Sınırsız GPT analizi", "Claude analizi (yakında)", "Tüm Pro özellikleri"],
    yakinda: true },
];

export default function Pricing() {
  const { pricingMsg, closePricing, plan } = useAuth();
  if (pricingMsg === null) return null;
  const mevcut = plan?.plan || "free";

  return (
    <div onClick={closePricing}
      style={{ position:"fixed", inset:0, background:"rgba(15,20,30,.55)", zIndex:1000,
               display:"flex", alignItems:"center", justifyContent:"center", padding:16, overflowY:"auto" }}>
      <div onClick={e => e.stopPropagation()}
        style={{ background:"#fff", borderRadius:14, width:"100%", maxWidth:760,
                 boxShadow:"0 20px 60px rgba(0,0,0,.3)", overflow:"hidden", margin:"auto" }}>
        <div style={{ padding:"20px 24px", borderBottom:"1px solid #eee", display:"flex", justifyContent:"space-between", alignItems:"flex-start" }}>
          <div>
            <div style={{ fontSize:19, fontWeight:800 }}>Planını seç</div>
            {pricingMsg
              ? <div style={{ fontSize:13, color:"#b45309", marginTop:4 }}>{pricingMsg}</div>
              : <div style={{ fontSize:13, color:"#6b7280", marginTop:4 }}>Daha fazla analiz için yükselt.</div>}
          </div>
          <button onClick={closePricing} style={{ fontSize:20, border:"none", background:"none", cursor:"pointer", color:"#9ca3af" }}>✕</button>
        </div>

        <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(210px, 1fr))", gap:12, padding:20 }}>
          {PLANLAR.map(p => {
            const secili = mevcut === p.id;
            return (
              <div key={p.id}
                style={{ border: p.vurgu ? "2px solid #2563eb" : "1px solid #e5e7eb", borderRadius:12,
                         padding:"18px 16px", position:"relative", background: p.vurgu ? "#f8fbff" : "#fff" }}>
                {p.vurgu && <div style={{ position:"absolute", top:-10, left:16, background:"#2563eb", color:"#fff",
                  fontSize:10, fontWeight:700, padding:"2px 10px", borderRadius:10, letterSpacing:".04em" }}>POPÜLER</div>}
                <div style={{ fontSize:15, fontWeight:800 }}>{p.ad}</div>
                <div style={{ fontSize:26, fontWeight:800, margin:"6px 0 12px", letterSpacing:"-.02em" }}>
                  {p.fiyat}<span style={{ fontSize:12, color:"#9ca3af", fontWeight:500 }}>{p.id!=="free" ? "/ay" : ""}</span>
                </div>
                <div style={{ display:"grid", gap:7, marginBottom:14 }}>
                  {p.ozellikler.map(o => (
                    <div key={o} style={{ fontSize:12.5, color:"#374151", display:"flex", gap:7, alignItems:"flex-start" }}>
                      <span style={{ color: o.includes("yakında") ? "#9ca3af" : "#16a34a", flexShrink:0 }}>
                        {o.includes("yakında") ? "○" : "✓"}</span>
                      <span style={{ color: o.includes("yakında") ? "#9ca3af" : "#374151" }}>{o}</span>
                    </div>
                  ))}
                </div>
                {secili ? (
                  <div style={{ textAlign:"center", fontSize:12.5, fontWeight:700, color:"#16a34a",
                                border:"1px solid #bbf7d0", borderRadius:8, padding:"9px" }}>Mevcut planın</div>
                ) : (
                  <button disabled title="Ödeme akışı yakında"
                    style={{ width:"100%", padding:"9px", borderRadius:8, border:"none",
                             background: p.vurgu ? "#2563eb" : "#111827", color:"#fff", fontSize:12.5, fontWeight:700,
                             cursor:"not-allowed", opacity:.55 }}>
                    {p.yakinda ? "Yakında" : "Yakında"}
                  </button>
                )}
              </div>
            );
          })}
        </div>
        <div style={{ padding:"0 24px 18px", fontSize:11, color:"#9ca3af", textAlign:"center" }}>
          Ödeme entegrasyonu henüz bağlı değil — planlar tanıtım amaçlı. Hesap TahminLigi ile ortaktır.
        </div>
      </div>
    </div>
  );
}
